export default function FooterSection() {
  return (
    <footer
      className="px-[60px] py-8 border-t border-[#1e1a18] bg-[#060606] flex items-center justify-between max-md:px-6 max-md:flex-col max-md:gap-3 max-md:text-center"
      style={{ fontFamily: "'Work Sans', sans-serif" }}
    >
      <div className="text-[12px] font-bold tracking-[0.12em] text-[#b8b2ac] uppercase">
        Jessica <span className="text-[#d43742]">AI</span> &nbsp;&middot;&nbsp; Your Delegate
      </div>
      <div className="text-[11px] text-[#b8b2ac] tracking-[0.06em]">
        delegate.petergits.com &nbsp;&middot;&nbsp; 2026
      </div>
    </footer>
  );
}
